"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LicenseGroup = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

class LicenseGroup {
  /**
   * @description Creates a new LicenseGroup for use.
   *
   * @param {Object} options Initialization Object (params described below)
   * @param {Number} options.adminCount - number of admins assigned to license group
   * @param {Boolean} options.administerable - Whether or not the license group is administerable
   * @param {String} options.contractType - Type of contract
   * @param {Number} options.delegatableCreditQuota - number of credits that can be used
   * @param {Number} options.delegatableImageQuota - number of images that can be used
   * @param {Number} options.delegatableVideoQuota - number of videos that can be used
   * @param {Number} options.delegatedQuantity - number of delegated users in the license group
   * @param {String} options.description - Description of the license group
   * @param {Array} options.dmaProductRoles - An array of roles for the license group
   * @param {Array} options.fulfilledItems - fulfilled items configured for this license group
   * @param {String} options.id - The id of of the license group
   * @param {String} options.name - The name of the license group
   * @param {Boolean} options.notifications - Whether or not notifications are enabled on the license group
   * @param {String} options.orgId - the org id
   * @param {Array} options.privateClouds - list of private clouds set-up for this license group
   * @param {Product} options.product - product model. If this is passed, it will supersede
   *                                    productCode, productFamily, productId and productName and it may use
   *                                    isEnterprise and isAdobeStock.
   * @param {String} options.productCode - Code of the product
   * @param {String} options.productFamily - Family of the product
   * @param {String} options.productId - Id of the product
   * @param {String} options.productName - Name of the product
   * @param {Number} options.provisionedQuantity - number of provisioned users in the license group
   * @param {Boolean} options.removable - true if license group is removable, else false
   * @param {Object} options.solutionGroup - solution group license group belongs to
   * @param {String} options.totalQuantity - number of licenses that can be assigned
   */
  constructor(options) {
    this.adminCount = options.adminCount;
    this.administerable = options.administerable;
    this.routeToMarket = options.routeToMarket;
    this.delegatableCreditQuota = options.delegatableCreditQuota;
    this.delegatableImageQuota = options.delegatableImageQuota;
    this.delegatableVideoQuota = options.delegatableVideoQuota;
    this.delegatedQuantity = options.delegatedQuantity;
    this.description = options.description;
    this.dmaProductRoles = options.dmaProductRoles;
    this.fulfilledItems = options.fulfilledItems;
    this.id = options.id;
    this.name = options.name;
    this.notifications = options.notifications;
    this.orgId = options.orgId;
    this.product = options.product;
    this.productCode = options.productCode;
    this.productFamily = options.productFamily;
    this.productId = options.productId;
    this.productName = options.productName;
    this.provisionedQuantity = options.provisionedQuantity;
    this.solutionGroup = options.solutionGroup;
  }

}

exports.LicenseGroup = LicenseGroup;